/**
 * すき焼きLP - メインJavaScript
 * スクロールアニメーションとカルーセル機能を実装
 */

(function() {
    'use strict';

    // ========================================
    // 初期化処理
    // ========================================
    
    // ページロード時のアニメーション防止
    document.body.classList.add('preload');
    
    window.addEventListener('load', function() {
        // ページロード完了後、アニメーションを有効化
        setTimeout(function() {
            document.body.classList.remove('preload');
        }, 100);
        
        // 各機能を初期化
        initScrollAnimations();
        initCarousel();
    });

    // ========================================
    // スクロールアニメーション機能
    // ========================================
    
    /**
     * スクロールアニメーションの初期化
     * Intersection Observer APIを使用してビューポートに入った要素をアニメーション
     */
    function initScrollAnimations() {
        // アニメーション対象の要素を取得
        const animatedElements = document.querySelectorAll('[data-animation]');
        
        if (!animatedElements.length) return;

        // Intersection Observerのオプション設定
        const observerOptions = {
            root: null, // ビューポートをルートとして使用
            rootMargin: '0px 0px -100px 0px', // 下から100px手前でトリガー
            threshold: 0.1 // 要素の10%が見えたらトリガー
        };

        // 同時アニメーショングループを管理
        const simultaneousGroups = {};

        // Observer作成
        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    const element = entry.target;
                    const animationType = element.getAttribute('data-animation');
                    const simultaneousId = element.getAttribute('data-simultaneous');
                    
                    // 同時アニメーションの処理
                    if (simultaneousId) {
                        // グループIDを生成（両方向で同じIDになるように）
                        const groupKey = getSimultaneousGroupKey(element, simultaneousId);
                        
                        if (!simultaneousGroups[groupKey]) {
                            simultaneousGroups[groupKey] = [];
                        }
                        simultaneousGroups[groupKey].push(element);
                        
                        // ペアの要素を探す
                        const pairElement = findSimultaneousPair(element, simultaneousId);
                        if (pairElement) {
                            simultaneousGroups[groupKey].push(pairElement);
                        }
                        
                        // 両方の要素が揃ったら同時にアニメーション
                        if (simultaneousGroups[groupKey].length >= 2) {
                            simultaneousGroups[groupKey].forEach(function(el) {
                                triggerAnimation(el);
                                observer.unobserve(el);
                            });
                        }
                    } else {
                        // 通常のアニメーション
                        triggerAnimation(element);
                        observer.unobserve(element); // 一度だけアニメーション
                    }
                }
            });
        }, observerOptions);

        // 各要素を監視対象に追加
        animatedElements.forEach(function(element) {
            observer.observe(element);
        });
    }

    /**
     * 同時アニメーショングループのキーを生成
     */
    function getSimultaneousGroupKey(element, simultaneousId) {
        // クラス名またはdata-simultaneous値からユニークなキーを生成
        const elementClass = element.className.split(' ').find(function(cls) {
            return cls.includes('section-') || cls.includes('fv-');
        }) || '';
        return elementClass + '-' + simultaneousId;
    }

    /**
     * 同時アニメーションのペア要素を探す
     */
    function findSimultaneousPair(element, simultaneousId) {
        // data-simultaneousが一致する他の要素を探す
        const allElements = document.querySelectorAll('[data-simultaneous]');
        for (let i = 0; i < allElements.length; i++) {
            const el = allElements[i];
            if (el !== element) {
                const elSimId = el.getAttribute('data-simultaneous');
                const elClass = el.className;
                const elementClass = element.className;
                
                // クラス名が一致するか、data-simultaneousが相互参照している場合
                if (elClass.includes(simultaneousId) || elementClass.includes(elSimId)) {
                    return el;
                }
            }
        }
        return null;
    }

    /**
     * アニメーションをトリガー
     */
    function triggerAnimation(element) {
        const animationType = element.getAttribute('data-animation');
        
        // アニメーションタイプに応じたクラスを追加
        switch(animationType) {
            case 'fadeInDown':
                element.classList.add('animate-fadeInDown');
                break;
            case 'slideInLeft':
                element.classList.add('animate-slideInLeft');
                break;
            case 'slideInRight':
                element.classList.add('animate-slideInRight');
                break;
        }
    }

    // ========================================
    // カルーセル機能
    // ========================================
    
    /**
     * カルーセルの初期化
     */
    function initCarousel() {
        const carouselContainer = document.querySelector('.carousel-container');
        if (!carouselContainer) return;

        const track = carouselContainer.querySelector('.carousel-track');
        const slides = carouselContainer.querySelectorAll('.carousel-slide');
        const prevBtn = carouselContainer.querySelector('.carousel-prev');
        const nextBtn = carouselContainer.querySelector('.carousel-next');
        const dotsContainer = carouselContainer.querySelector('.carousel-dots');

        if (!track || !slides.length) return;

        let currentIndex = 0;
        const totalSlides = slides.length;
        let autoPlayInterval;

        // ドットインジケーターを生成
        createDots();

        // イベントリスナーを設定
        if (prevBtn) {
            prevBtn.addEventListener('click', function() {
                goToPrevSlide();
                resetAutoPlay();
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', function() {
                goToNextSlide();
                resetAutoPlay();
            });
        }

        // タッチスワイプ対応
        let touchStartX = 0;
        let touchEndX = 0;

        track.addEventListener('touchstart', function(e) {
            touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });

        track.addEventListener('touchend', function(e) {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        }, { passive: true });

        function handleSwipe() {
            const swipeThreshold = 50;
            const diff = touchStartX - touchEndX;

            if (Math.abs(diff) > swipeThreshold) {
                if (diff > 0) {
                    // 左スワイプ - 次へ
                    goToNextSlide();
                } else {
                    // 右スワイプ - 前へ
                    goToPrevSlide();
                }
                resetAutoPlay();
            }
        }

        /**
         * ドットインジケーターを作成
         */
        function createDots() {
            if (!dotsContainer) return;

            for (let i = 0; i < totalSlides; i++) {
                const dot = document.createElement('div');
                dot.classList.add('carousel-dot');
                if (i === 0) dot.classList.add('active');
                
                dot.addEventListener('click', function() {
                    goToSlide(i);
                    resetAutoPlay();
                });
                
                dotsContainer.appendChild(dot);
            }
        }

        /**
         * 指定したスライドに移動
         */
        function goToSlide(index) {
            currentIndex = index;
            updateCarousel();
        }

        /**
         * 前のスライドに移動
         */
        function goToPrevSlide() {
            currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
            updateCarousel();
        }

        /**
         * 次のスライドに移動
         */
        function goToNextSlide() {
            currentIndex = (currentIndex + 1) % totalSlides;
            updateCarousel();
        }

        /**
         * カルーセルの表示を更新
         */
        function updateCarousel() {
            // スライドを移動
            const offset = -currentIndex * 100;
            track.style.transform = 'translateX(' + offset + '%)';

            // ドットの状態を更新
            if (dotsContainer) {
                const dots = dotsContainer.querySelectorAll('.carousel-dot');
                dots.forEach(function(dot, index) {
                    if (index === currentIndex) {
                        dot.classList.add('active');
                    } else {
                        dot.classList.remove('active');
                    }
                });
            }
        }

        /**
         * 自動再生を開始
         */
        function startAutoPlay() {
            autoPlayInterval = setInterval(function() {
                goToNextSlide();
            }, 5000); // 5秒ごとに次のスライドへ
        }

        /**
         * 自動再生をリセット
         */
        function resetAutoPlay() {
            clearInterval(autoPlayInterval);
            startAutoPlay();
        }

        // 自動再生を開始
        startAutoPlay();

        // ページが非表示になったら自動再生を停止
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                clearInterval(autoPlayInterval);
            } else {
                startAutoPlay();
            }
        });
    }

    // ========================================
    // jQuery inviewプラグインのフォールバック
    // ========================================
    
    /**
     * jQuery inviewプラグインが利用可能な場合の追加処理
     * (既存のjquery.inview.min.jsとの互換性のため)
     */
    if (typeof jQuery !== 'undefined' && jQuery.fn.on) {
        jQuery(function($) {
            // inviewイベントのサポート（オプション）
            $('[data-animation]').on('inview', function(event, isInView) {
                if (isInView) {
                    triggerAnimation(this);
                }
            });
        });
    }

})();
